import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SupportContact {
    phoneNumber = '888-671-9395';
    email = 'support@personifyhealth.com';
}
